import { EditOutlined } from '@mui/icons-material';
import { ListItemIcon, MenuItem } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { PopupState } from 'material-ui-popup-state/hooks';
import { useVerifyEmailLink } from './verify-email-link-menu-item.hooks';
import { useEffect } from 'react';

type VerifyEmailLinkMenuItemProps = {
  popupState: PopupState;
  userId: string;
};

const VerifyEmailLinkMenuItem = ({
  popupState,
  userId,
}: VerifyEmailLinkMenuItemProps) => {
  const { t } = useTranslation();
  const { triggerVerifyEmail, isLoading, isSuccess } = useVerifyEmailLink();

  const handleVerifyEmail = () => {
    triggerVerifyEmail({ userId });
  };

  useEffect(() => {
    if (isSuccess) popupState.close();
  }, [isSuccess, popupState]);

  return (
    <MenuItem onClick={handleVerifyEmail} disabled={isLoading}>
      <ListItemIcon>
        <EditOutlined fontSize="small" />
      </ListItemIcon>
      {t('page.customers.card.verifyEmail')}
    </MenuItem>
  );
};

export default VerifyEmailLinkMenuItem;
